// extracted by mini-css-extract-plugin
export var blue = "Title-module--blue--xxS64";
export var container = "Title-module--container--cVJT8";